import { useState, useEffect, useRef } from 'react';

const useIntersectionObserver = ({
  threshold = 0.3,
  root = null,
  rootMargin = '0px',
  once = true, // pass true if you only want it to trigger once
} = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          if (once) observer.disconnect(); // fire once if needed
        } else {
          setIsIntersecting(false);
        }
      },
      { root, rootMargin, threshold },
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [root, rootMargin, threshold, once]);

  return { ref, isIntersecting };
};

export default useIntersectionObserver;
